import { render, staticRenderFns } from "./virtualCard.vue?vue&type=template&id=5304839f"
import script from "./virtualCard.vue?vue&type=script&lang=ts"
export * from "./virtualCard.vue?vue&type=script&lang=ts"
import style0 from "./virtualCard.vue?vue&type=style&index=0&id=5304839f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports